import {
  OnChanges,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { PriceCategoryWidget } from "src/app/models/booking/price_category_widget.enum";
import { Registration } from "src/app/models/booking/reservation.interface";
import { EventService } from "src/app/services/event.service";

import { AsyncDependencyConsumer } from "../../base-classes/async-dependency-consumer";
import { Config } from "../../interfaces/config";
import { PriceCategory } from "../../models/registration/price-category.interface";
import { ConfigService } from "../../services/config.service";
import {
  PriceCategoryService,
  PriceCategoryMode,
} from "../../services/price-category.service";

@Component({
  selector: "app-price-category",
  templateUrl: "./price-category.component.html",
  styleUrls: ["./price-category.component.scss"],
})
export class PriceCategoryComponent
  extends AsyncDependencyConsumer
  implements OnChanges
{
  @Input() registration: Registration;

  @Output() categoryChange: EventEmitter<PriceCategory> = new EventEmitter<PriceCategory>();

  private ready: boolean;
  private validation: boolean;
  config_data: Config;
  visible_price_categories: PriceCategory[] = [];

  PriceCategoryWidget = PriceCategoryWidget;

  constructor(
    private config_service: ConfigService,
    private price_category_service: PriceCategoryService,
    private event_service: EventService
  ) {
    super();
    this.init(price_category_service, event_service);
  }

  ngOnChanges(): void {
    if (this.ready) {
      this.set_price_categories();
    }
    this.config_data = this.config_service.config;
  }

  protected onReady(): void {
    this.ready = true;
    this.ngOnChanges();
  }

  private set_price_categories() {
    if (!this.registration) {
      return;
    }

    this.visible_price_categories =
      this.price_category_service.get_visible_price_categories(
        this.registration.event_id
      );

    const program_id = this.event_service.get_program_on_event_id(this.registration.event_id).program_id;
    const selected_price_category = this.visible_price_categories.find(
      (cat) => {
        return this.price_category_service.check(
          cat,
          this.validation,
          program_id,
          PriceCategoryMode.SELECT,
          this.registration.zi.display_normalpreis
        );
      }
    );

    if (selected_price_category) {
      this.registration.price_category = selected_price_category.id;
      this.registration.zi.price = selected_price_category.price;
    }
  }

  select_category(category_id: string): void {
    const price_category = this.visible_price_categories.find(
      (category) => category.id === parseInt(category_id, 10)
    );

    this.categoryChange.emit(price_category);
  }
}
